import { render, staticRenderFns } from "./ContentSectionMenu.vue?vue&type=template&id=b3c7a0a6&scoped=true&"
import script from "./ContentSectionMenu.vue?vue&type=script&lang=js&"
export * from "./ContentSectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentSectionMenu.vue?vue&type=style&index=0&id=b3c7a0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c7a0a6",
  null
  
)

export default component.exports